/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Staff_OrdersInputs */

const vi_report_staff_orders = /** @type {(inputs: Report_Staff_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số đơn`)
};

/**

* @param {Report_Staff_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_staff_orders = /** @type {((inputs?: Report_Staff_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Staff_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_staff_orders(inputs)
});